import React from 'react';
import {Link} from 'react-router-dom';
import {ChevronLeft} from 'lucide-react';
import PageHeader from '@/shared/layout/PageHeader';

interface ProviderPageHeaderProps {
    title: string;
    subtitle?: string;
    /** Hide the breadcrumb back-link (e.g. on the top-level Provider Console page) */
    hideBreadcrumb?: boolean;
    /** Slot for action buttons on the right side of the header */
    action?: React.ReactNode;
}

const ProviderPageHeader: React.FC<ProviderPageHeaderProps> = ({title, subtitle, hideBreadcrumb, action}) => {
    return (
        <div>
            {!hideBreadcrumb && (
                <Link
                    to="/provider"
                    state={{fromConsoleLink: true}}
                    className="inline-flex items-center gap-0.5 text-sm text-mld-text-secondary hover:text-mld-text-primary transition-colors">
                    <ChevronLeft className="h-4 w-4" />
                    Provider Console
                </Link>
            )}
            <div className="flex items-center justify-between">
                <PageHeader title={title} subtitle={subtitle} className={hideBreadcrumb ? 'my-0' : 'mt-1'} />
                {action && <div className="shrink-0">{action}</div>}
            </div>
        </div>
    );
};

export default ProviderPageHeader;
